export default __webpack_public_path__ + "static/spkz-997518ffb2b719278b694ad2fbd4bdcc.jpg";